
import Vue from 'vue';
import {
  Label, SelectionResult,
} from '@/model';
import labels from '@/store/labels';
import {
  distinct, groupBy,
} from '@/util/array-util';
import DataTable, { Column } from '@/components/tables/DataTable.vue';

interface LabelFrequency {
  labelId: number;
  labelCode: string;
  labelType: string
  documents: number;
  pages: number;
  boxes: number;
  fragments: number;
  chars: number;
  // words: number;
}

interface LabelFragment {
  documentId: number;
  ingestionId: number;
  pageId: number;
  boxId: number;
  fragments: number[];
  labelId: number;
  from: number;
  to: number;
}

export default Vue.extend({
  components: { DataTable },
  props: {
    value: { type: Object as () => SelectionResult, required: true },
  },
  data() {
    return {
      tableHeaders: [
        { header: 'Id', value: 'labelId', type: 'string' },
        {
          header: 'Label', value: 'labelCode', type: 'string',
        },
        {
          header: 'Type', value: 'labelType', type: 'string', filterable: true,
        },
        {
          header: 'Documents', value: 'documents', type: 'number', sort: 'desc',
        },
        {
          header: 'Pages', value: 'pages', type: 'number', sort: 'desc',
        },
        {
          header: 'Boxes', value: 'boxes', type: 'number', sort: 'desc',
        },
        {
          header: 'Fragments', value: 'fragments', type: 'number', sort: 'desc',
        },
        {
          header: 'Characters', value: 'chars', type: 'number', sort: 'desc',
        },
      ] as Column[],
    };
  },

  computed: {
    labels(): Label[] {
      return labels.state.labels
        .filter((l) => l.selectable);
    },
    labelFragments(): LabelFragment[] {
      return this.value.docs.flatMap((d) => d.pages.flatMap((p) => p.boxes.flatMap((b) => b.slices.flatMap((s) => s.labels.map((l) => ({
        documentId: d.document.id,
        ingestionId: d.ingestId,
        pageId: p.pageId,
        boxId: b.boxId,
        fragments: [...s.fragments],
        labelId: l,
        from: s.from,
        to: s.to,
      }))))));
    },
    labelFrequency(): LabelFrequency[] {
      const labelsWithData = Array.from(groupBy(this.labelFragments, (f) => f.labelId))
        .map(([labelId, fragments]) => {
          const label = labels.getters.lookup.get(labelId) as Label;
          return {
            labelId,
            labelCode: label?.code,
            labelType: label?.type,
            documents: distinct(fragments.map((f) => f.documentId)).length,
            pages: distinct(fragments.map((f) => f.pageId)).length,
            boxes: distinct(fragments.map((f) => f.boxId)).length,
            fragments: fragments.length,
            chars: fragments.map((f) => f.to - f.from).reduce((a, b) => a + b, 0),
          };
        });

      const labelsWithDataIds = new Set(labelsWithData.map((l) => l.labelId));

      // add labels without data
      return this.labels
        .filter((l) => !labelsWithDataIds.has(l.id))
        .map((l) => ({
          labelId: l.id,
          labelCode: l.code,
          labelType: l.type,
          documents: 0,
          pages: 0,
          boxes: 0,
          fragments: 0,
          chars: 0,
        }))
        .concat(labelsWithData);
    },
  },
});
